import { useCallback, useEffect, useState } from 'react';
import { listReservations } from '@/modules/reservations/services';
import type { Reservation } from '@/modules/reservations/types';

export function useReservations() {
  const [reservations, setReservations] = useState<Reservation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setReservations(await listReservations());
    } catch {
      setError('No se pudieron cargar las reservas.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { reservations, loading, error, refresh };
}
